import { all } from 'redux-saga/effects';

import consultaCanaisSaga from './consultaCanais/saga';

export default all([consultaCanaisSaga]);
